import '@progress/kendo-theme-default/dist/all.css';
import "@fontsource/manrope/latin-400.css";
import "@fontsource/manrope/latin-ext-400.css";
import "flag-icons/css/flag-icons.min.css";

import './styles/components.css';
import './styles/theme-light.css';
import './styles/theme-dark.css';

import './styles/index.css';
import './styles/icons.css';
import './styles/navigation.css';
import './styles/colors.css';
import './styles/elements.css';
import './styles/display.css';
import './styles/space.css';
import './styles/map.css';
import './styles/sizes.css';

import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { getElementById } from './components/helpers/ElementHelpers';
import { AppStore } from './components/stores/AppStore';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = getElementById('root');
const root = createRoot(rootElement);

async function enableMocking() {
    if (!import.meta.env.DEV) {
        return;
    }

    const { worker } = await import('./mocks/browser');
    return worker.start({ onUnhandledRequest: "bypass" });
}

// ref. bug #23454
//enableMocking().then(() => {
root.render(
    <BrowserRouter
        future={{
            v7_relativeSplatPath: true,
            v7_startTransition: true,
        }}
        basename={baseUrl}>
        <App />
    </BrowserRouter>);
//});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register({
    onUpdate: registration => {

        AppStore.getState().setServiceWorkerRegistration(registration);

        if(!registration) return;
        const url = new URL(window.location.href);
        url.searchParams.set('newVersion', 'true');
        window.history.pushState({}, '', url);
    }
});
// missing PubSub.publish(PubSubTopics.UpdateServiceWorker, registration);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
